import React from "react";
import HelpingNeighbour from "./assets/helping-neighbour.png";
import VolunteerFlow from "./assets/VolunteerManagementFlow.svg";
import "./styles/volunteerpage.css";
import SectionHeader from "../landingpage/SectionHeader";
import { volunteerOpportunities } from "./VolunteerPageComponentData";
import bgDownArrow from "./assets/bg-down-arrow.svg";
import spiral_1 from "./assets/spiral_1.svg";
import { Helmet } from "react-helmet-async";
import FAQSection from "./component/FAQSection";
import HeaderComponent from "../landingpage/header/HeaderComponent";
import FooterComponent from "../landingpage/footer/FooterComponent";
import StickyButton from "../../components/generic/stickybutton/StickyButton";

const VolunteerPageComponent = () => {
  return (
    <>
      <Helmet>
        <title>Join Our Hospice Volunteer Program | Patient Data Vault</title>
        <meta
          name="description"
          content="Join our hospice volunteer program and make a meaningful impact. Patient Data Vault helps you track, manage, and engage in volunteer activities seamlessly."
        />
        <meta
          property="og:title"
          content="Join Our Hospice Volunteer Program | Patient Data Vault"
        />
      </Helmet>
            <StickyButton />
      <div className="pdv-volunteer-page">
        {/* header section */}
        <HeaderComponent />
        {/* be the volunteer section */}
        <section className="volunteer-section">
          <div className="container">
            <div className="row pt-2">
              <div className="col-md-6 d-flex flex-column justify-content-center align-items-center text-center text-md-start px-4">
                <div>
                  <h1 className="volunteer-heading">Be the volunteer</h1>
                  <p className="my-2 volunteer-text">
                    Join our community of dedicated volunteers making a
                    difference in the lives of hospice patients and their
                    families.
                  </p>
                  <a
                    href="https://ihva.org/?goToLogin=true"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="volunteer-section-btn">
                      Members Login
                    </button>
                  </a>
                </div>
              </div>
              <div className="col-md-6 d-flex justify-content-center align-items-center">
                <div className="helping-image-container">
                  <img
                    src={HelpingNeighbour}
                    alt="Hospice volunteer , care , Compassion , volunteering"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="volunteer-back-image">
          <div className="volunteer-icon-down-arrow">
            <img src={bgDownArrow} alt="bg-down-arrow" />
          </div>
          <div className="volunteer-icon-spiral-1">
            <img src={spiral_1} alt="bg-spiral" />
          </div>
          {/* Volunteer Management Solutions section */}
          <section className="d-flex flex-column justify-content-center align-items-center volunteer-management-container mt-3">
            <SectionHeader title="Volunteer Management Solutions" />
            <div className="image-container">
              <img
                src={VolunteerFlow}
                alt="Hospice volunteer management process , volunteer management flow "
              />
            </div>
          </section>

          {/* Volunteer Opportunities section */}
          <section className="container mt-3">
            <SectionHeader title="Volunteer Opportunities" />
            <div className="container">
              <div className="row justify-content-center d-flex align-items-stretch position-relative z-1">
                {volunteerOpportunities.map((item, i) => (
                  <div className="col-12 col-sm-6 col-md-3 d-flex" key={i}>
                    <div className="values-card p-3 text-center mx-auto d-flex flex-column">
                      <img
                        src={item.icon}
                        className="mx-auto d-block"
                        alt={item.alt}
                      />
                      <p className="mt-3 volunteer-card-title">{item.title}</p>
                      <p className="volunteer-text">{item.decscription}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>

        {/* Frequently asked question section */}
        <FAQSection />

        <div className="volunteer-back-image">
          {/* Explore PDV section */}
          <section className="volunteer-demo">
            <SectionHeader title="Explore HVA" />
            <p className="volunteer-demo-description">
              The recognized organization in the U.S. representing hospice
              volunteers and managers providing training and educational
              resources. Current membership is 10,000 members
            </p>
            <a
              href="https://ihva.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="volunteer-section-btn">Explore More</button>
            </a>
          </section>
        </div>
        {/* <FooterComponent /> */}
        <FooterComponent />
      </div>
    </>
  );
};

export default VolunteerPageComponent;
